import wasteCalendarTranslations from '../../../../apps/waste-calendar/config/i18next/locales/nl.json';
import heatCalculatorTranslations from '../../../../apps/heat-calculator/config/i18next/locales/nl.json';
import reportsTranslations from '../../../../apps/reports/config/i18next/locales/nl.json';
import registrationDeskTranslations from '../../../../apps/registration-desk/config/i18next/locales/nl.json';
import containerLocationsTranslations from '../../../../apps/container-locations/config/i18next/locales/nl.json';
import { i18nextNL } from '@hvcgroep/design-system';

export default {
  "translation": {
    ...i18nextNL.translation,
    "waste_calendar": wasteCalendarTranslations,
    "heat_calculator": heatCalculatorTranslations,
    "reports": reportsTranslations,
    "registration_desk": registrationDeskTranslations,
    "container_locations": containerLocationsTranslations,
    "not_found": {
      "no_app_with_id": "No app found with ID {{id}}.",
      "no_id": "Please specify the app ID."
    },
    "journey": {
      "next": "Volgende",
      "back": "Terug"
    },
    "address_selection": {
      "form": {
        "label": "Adres",
        "button": {
          "submit": "Toon inzameldata"
        },
        "error": {
          "label": "...",
          "server_error": "Er ging iets mis bij het ophalen van de adressen",
          "not_hvc_waste_address": "Op dit adres zamelen wij geen afval in",
          "no_results": "Er kon met deze postcode/huisnummer combinatie geen adres gevonden worden."
        }
      },
      "info": {
        "label": "Je adres",
        "change_address": "Ander adres"
      }
    },
  }
};
